// extracted by mini-css-extract-plugin
module.exports = {"XGuard":"XGuard_XGuard__tdPty"};